import { BUTTON_STYLES } from '../../../../../theme/buttonStyles';
import { BLACK, PRIMARY_COLOR } from '../../../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../../../theme/fontConstants';

const modalStyles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalBox: {
    position: 'relative',
    width: { xs: '90vw', sm: '80vw', md: '60vw', lg: '50vw' },
    bgcolor: 'background.paper',
    borderRadius: 4,
    boxShadow: 24,
    p: 3,
    maxHeight: '90vh',
    overflow: 'hidden',
  },
  contentBox: {
    maxHeight: 'calc(90vh - 32px)',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  title: {
    fontSize: '24px',
    textAlign: 'left',
    color: BLACK[100],
    fontFamily: PRIMARY_FONT[700],
  },
  subtitle: {
    fontSize: '16px',
    fontFamily: PRIMARY_FONT[300],
    textAlign: 'left',
    color: BLACK[70],
  },
  optionsContainer: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    gap: 3,
  },
  optionCard: {
    flex: 1,
    border: `2px solid ${BLACK[30]}`,
    borderRadius: 4,
    p: 3,
    pb: 4,
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    position: 'relative',
    minHeight: '180px',
    display: 'flex',
    flexDirection: 'column',
    '&:hover': {
      borderColor: PRIMARY_COLOR[70],
      boxShadow: `0 4px 12px ${PRIMARY_COLOR[20]}`,
    },
  },
  selectedOptionCard: {
    borderColor: PRIMARY_COLOR[70],
    backgroundColor: PRIMARY_COLOR[30],
    boxShadow: `0 4px 12px ${PRIMARY_COLOR[20]}`,
  },
  optionTitle: {
    fontSize: '20px',
    fontFamily: PRIMARY_FONT[700],
    color: PRIMARY_COLOR[70],
    mb: 1.5,
  },
  optionDescription: {
    fontSize: '16px',
    fontFamily: PRIMARY_FONT[300],
    color: BLACK[70],
    mb: 1.5,
    flex: 1,
  },
  selectionIndicator: {
    display: 'flex',
    height: '24px',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 1,
    flexShrink: 0,
    mt: 1,
  },
  radioButton: {
    width: 20,
    height: 20,
    border: `2px solid ${PRIMARY_COLOR[70]}`,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },
  selectedRadioButton: {
    backgroundColor: PRIMARY_COLOR[70],
  },
  radioInner: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'white',
  },
  selectedText: {
    fontSize: '16px',
    color: PRIMARY_COLOR[70],
    fontFamily: PRIMARY_FONT[700],
    fontStyle: 'italic',
    whiteSpace: 'nowrap',
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 2,
    mb: 2,
  },
  cancelButton: BUTTON_STYLES.cancel,
  nextButton: BUTTON_STYLES.contained,
};

export default modalStyles;
